import { JsonRestApiRequestConfig, makeJsonRestApiRequest } from '~src/httpClient/RestApiService';

export function callUpdateDatasourceRevisionMetadata(
  datasourceId: string,
  versionNumber: number,
  notes: string
): Promise<void> {
  const config: JsonRestApiRequestConfig = {
    restApiVersion: '3.30',
    httpMethod: 'PATCH',
    endpoint: `datasources/${datasourceId}/revisions/${versionNumber}/metadata`,
    serverWideRequest: false,
  };
  return makeJsonRestApiRequest<{ notes: string }, void>({ config, request: { notes } });
}
